import { useShallow } from 'zustand/shallow';

import { store } from './store';

export const useDailies = () =>
  store(
    useShallow((state) => ({
      data: state.data,
      loading: state.loading,
      error: state.error,
      fetchCalendar: state.fetchCalendar,
      assign: state.assign,
      remove: state.remove,
      reset: state.reset,
    })),
  );
